const STORAGE_PREFIX = 'kandor:assignment-reminder:'
export const ASSIGNMENT_REMINDER_COOLDOWN_MS = 60 * 60 * 1000

const storageKey = assignmentId =>
	`${STORAGE_PREFIX}${String(assignmentId || '').trim()}`

export const getReminderSentAt = (assignmentId) => {
	if (!assignmentId) return null
	try {
		const raw = localStorage.getItem(storageKey(assignmentId))
		if (!raw) return null
		const ts = Number(raw)
		return Number.isFinite(ts) ? ts : null
	} catch {
		return null
	}
}

export const isReminderOnCooldown = (assignmentId, now = Date.now()) => {
	const sentAt = getReminderSentAt(assignmentId)
	if (!sentAt) return false
	return now - sentAt < ASSIGNMENT_REMINDER_COOLDOWN_MS
}

export const getReminderCooldownRemainingMs = (assignmentId, now = Date.now()) => {
	const sentAt = getReminderSentAt(assignmentId)
	if (!sentAt) return 0
	const remaining = ASSIGNMENT_REMINDER_COOLDOWN_MS - (now - sentAt)
	return Math.max(0, remaining)
}

export const recordReminderSent = (assignmentId, now = Date.now()) => {
	if (!assignmentId) return
	try {
		localStorage.setItem(storageKey(assignmentId), String(now))
	} catch {
		// ignore quota / privacy mode
	}
}
